import React from 'react';
import './ContactInfo.css'
import InfoLine from '../Common/InfoLine';

const ContactInfo = () => {
    return ( 
        <div className='ContactInfo'>
            <p className='InfoTitle'>Contact Information</p>

            <div className='InfoLines'>
                <InfoLine LineName="Address" LineSub="123 Justice Boulevard, Suite 500 Legal District, LD 10101"/>
                <InfoLine LineName="Phone" LineSub="(555) 123-4567"/>
                <InfoLine LineName="Email" LineSub="contact@irongatelaw.com"/>
                <InfoLine LineName="Office Hours" LineSub="Monday - Friday: 9:00 AM - 6:00 PM Saturday: By Appointment "/>
            </div>
        </div>
     );
}
 
export default ContactInfo;